import b from 'b_';
import get from 'lodash/get';
import max from 'lodash/max';
import { coursePropType, getOffset, getHeight } from 'platform-components/utils';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';

import TableBody from '../__table-body/course-journal__table-body';
import { CourseJournalTableHead } from '../__table-head/course-journal__table-head';

import './course-journal__table.scss';

const CELL_PADDING = 76;
const HEAD_TO_CELL_FONT_SIZE_RATIO = 15 / 15;

const FIELD_TO_CELL_MOD = {
    student: 'course-journal__table-cell_student',
    username: 'course-journal__table-cell_username',
    lessons: 'course-journal__table-cell_lessons',
    total_efficiency: 'course-journal__table-cell_efficiency',
};

class CourseJournalTable extends React.Component {
    static propTypes = {
        course: coursePropType.isRequired,
        journal: PropTypes.array.isRequired,
        onOrderJournalBy: PropTypes.func.isRequired,
        ordering: PropTypes.shape({
            direction: PropTypes.number,
            field: PropTypes.string,
        }).isRequired,
        intl: PropTypes.object,
    };

    static childContextTypes = {
        addHoverCarouselScrollerListener: PropTypes.func,
        addScrollCarouselListener: PropTypes.func,
        addUnhoverCarouselScrollerListener: PropTypes.func,
        hoverCaroselsScrollers: PropTypes.func,
        scrollCarousels: PropTypes.func,
        unhoverCaroselsScrollers: PropTypes.func,
    };

    state = {
        fixedHead: false,
        headStyle: {},
        hoveredColumn: null,
    };

    getChildContext() {
        return {
            addHoverCarouselScrollerListener: this.addHoverCarouselScrollerListener,
            addScrollCarouselListener: this.addScrollCarouselListener,
            addUnhoverCarouselScrollerListener: this.addUnhoverCarouselScrollerListener,
            hoverCaroselsScrollers: this.hoverCaroselsScrollers,
            scrollCarousels: this.scrollCarousels,
            unhoverCaroselsScrollers: this.unhoverCaroselsScrollers,
        };
    }

    UNSAFE_componentWillMount() {
        this.hoverCarouselScrollerListener = [];
        this.scrollCarouselListeners = [];
        this.unhoverCarouselScrollerListener = [];
    }

    componentDidMount() {
        window.addEventListener('scroll', this.onScrollPage, { passive: true });
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScrollPage, { passive: true });
    }

    onTableRef = React.createRef();

    addScrollCarouselListener = (listener) => {
        this.scrollCarouselListeners.push(listener);
    };

    addHoverCarouselScrollerListener = (listener) => {
        this.hoverCarouselScrollerListener.push(listener);
    };

    addUnhoverCarouselScrollerListener = (listener) => {
        this.unhoverCarouselScrollerListener.push(listener);
    };

    scrollCarousels = (direction) => {
        for (let i = 0; i < this.scrollCarouselListeners.length; i += 1) {
            this.scrollCarouselListeners[i](direction);
        }
    };

    hoverCaroselsScrollers = (type) => {
        for (let i = 0; i < this.hoverCarouselScrollerListener.length; i += 1) {
            this.hoverCarouselScrollerListener[i](type);
        }
    };

    unhoverCaroselsScrollers = (type) => {
        for (let i = 0; i < this.unhoverCarouselScrollerListener.length; i += 1) {
            this.unhoverCarouselScrollerListener[i](type);
        }
    };

    /* eslint-disable no-unused-expressions */
    onScrollPage = () => {
        const pageY = window.scrollY;
        const { current } = this.onTableRef;

        if (typeof pageY !== 'number') {
            return;
        }
        const { fixedHead } = this.state;
        const tableBodyTop = getOffset(current).top;
        const tableBottom = tableBodyTop + getHeight(current);

        if (pageY < tableBodyTop || pageY > tableBottom) {
            fixedHead && this.setState({ fixedHead: false });
            return;
        }

        !fixedHead && this.setState({ fixedHead: true });
    };

    toggleColumnHover = (column = null) => {
        this.setState({ hoveredColumn: column });
    };

    getCellWidthStyle = (fields, headMessageId) => {
        const { intl, journal } = this.props;

        const rowsMax = max(journal.map((row) => fields.map((field) => get(row, field)).join(' ').length));
        const headLength = intl.formatMessage({ id: headMessageId }).length;
        const maxLength = Math.max(rowsMax, headLength);

        return {
            cell: `calc(${maxLength}ex + ${CELL_PADDING}px)`,
            head: `calc(${HEAD_TO_CELL_FONT_SIZE_RATIO} * ${maxLength}ex + ${CELL_PADDING}px)`,
        };
    };

    render() {
        const { course, journal, onOrderJournalBy, ordering } = this.props;
        const { fixedHead, hoveredColumn } = this.state;
        const className = b('course-journal__table', {
            'fixed-head': fixedHead,
        });

        const fullNameWidth = this.getCellWidthStyle(
            [
                ['student', 'last_name'],
                ['student', 'first_name'],
            ],
            'courseJournal.userFullName'
        );

        return (
            <div className={className} onMouseLeave={this.onMouseLeave} ref={this.onTableRef}>
                <CourseJournalTableHead
                    course={course}
                    fieldToMod={FIELD_TO_CELL_MOD}
                    fixed={fixedHead}
                    fullNameWidth={fullNameWidth.head}
                    hoveredColumn={hoveredColumn}
                    onOrderBy={onOrderJournalBy}
                    ordering={ordering}
                    toggleColumnHover={this.toggleColumnHover}
                />
                <TableBody
                    course={course}
                    fieldToMod={FIELD_TO_CELL_MOD}
                    fullNameWidth={fullNameWidth.cell}
                    hoveredColumn={hoveredColumn}
                    journal={journal}
                    ordering={ordering}
                    toggleColumnHover={this.toggleColumnHover}
                />
            </div>
        );
    }
}

export default injectIntl(CourseJournalTable);
